/*
 * Copyright (C) 2018 Paymentus Inc.
 *
 * All rights reserved.
 *
 * The source code in this file is confidential and is the sole property of
 * Paymentus Inc. Its use is restricted to those readers who are authorized by
 * the corporation. Any reverse engineering or reproduction or divulgence of the
 * content of this report without the written consent from Paymentus Inc. is
 * strictly prohibited.
 *
 * Created on 9/7/18 4:44 PM
 * Created by kxian
 *
 */

import Loadable from 'react-loadable'
import React from 'react'

function customizationLoader(tla, appName) {
    // Webpack dynamic import. See: https://webpack.js.org/guides/code-splitting/#dynamic-imports
    return import(/* webpackChunkName: "customization-[request]" */ `../customizations/custom-${appName ? appName + '-' : ''}${tla}`)
        .then(data => {
            console.log('Customizations loaded for:', tla, appName)
            return data
        })
        .catch(err => {
            console.warn('No customizations loaded for:', tla, appName, err)
            return {}
        })
}

const importDynamicComponent = (tla, name, defaultComponent) => Loadable({
    loader() {
        return customizationLoader((tla || '').toLowerCase())
            .then(data => data[name] || defaultComponent)
    },
    loading() {
        return <div>Loading...</div>
    }
})

export {
    importDynamicComponent,
    customizationLoader
}
